export default {
  darkPurple: '#28266E',
  darkBlue: '#0083CA',
  blue: '#00A9FF',
  lightBlue: '#98E2FA',
  blueBackground: '#98E2FA',
  green: '#006429',
  pink: '#8F00BA',
  gray01: '#4A4A4A',
  gray02: '#6F6F6F',
  gray03: '#93999C',
  gray04: '#DBDBDB',
  gray05: '#D7DCE6',
  gray06: '#F3F8FB',
  white: '#FFFFFF',
  success: '#00C78D',
  successBackground: '#C6E1D4',
  danger: '#EB0010',
  dangerBackground: '#FFD6DF',
  warning: '#FF9803',
  warningBackground: '#FFF7CD',
  gradient:
    'linear-gradient(224.43deg, #118ACA 0%, rgba(255, 255, 255, 0) 101.01%), #23336E',
};
